import axios from '../../localAxios';
import { mergeURL } from '../url';

export interface MergeQuizParams {
  name?: string;
  parentId: number;
  quizSoc1: string;
  quizSoc2: string;
}

export interface MergeQuizResponse {
  callback: () => void;
  createdDate: string;
  id: number;
  name: string;
  socNumber: string;
  sharable: boolean;
  version: number;
  soc: string;
  date: string;
  parentId: number;
  standard: string;
}

export async function mergeQuiz({
  name,
  parentId,
  quizSoc1,
  quizSoc2,
}: MergeQuizParams) {
  const url = mergeURL();
  const response = await axios.post<MergeQuizResponse>(url.href, {
    name,
    parentId,
    quizSoc1,
    quizSoc2: quizSoc2,
  });
  return response.data;
}
